import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ImplicitNeedsCard = ({ title, percentage, icon, description, trend }) => {
  const getColorClass = (value) => {
    if (value >= 75) return 'primary';
    if (value >= 50) return 'success';
    if (value >= 25) return 'warning';
    return 'danger';
  };

  const color = getColorClass(percentage);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -2 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-xl shadow-sm border border-secondary-200 p-6 hover:shadow-md transition-shadow"
    >
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 bg-gradient-to-br from-${color}-500 to-${color}-600 rounded-xl flex items-center justify-center`}>
          <SafeIcon icon={icon} className="w-6 h-6 text-white" />
        </div>
        <div className="text-right">
          <span className={`text-2xl font-bold text-${color}-600`}>{percentage}%</span>
          {trend && (
            <div className={`text-xs ${trend > 0 ? 'text-success-600' : 'text-danger-600'}`}>
              {trend > 0 ? '+' : ''}{trend}% vs last month
            </div>
          )}
        </div>
      </div>

      <h3 className="text-lg font-semibold text-secondary-900 mb-2">{title}</h3>
      <p className="text-sm text-secondary-600">{description}</p>

      <div className="mt-4">
        <div className="w-full bg-secondary-100 rounded-full h-2">
          <div
            className={`bg-gradient-to-r from-${color}-500 to-${color}-600 h-2 rounded-full`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default ImplicitNeedsCard;